import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_participate_in_any_of_the_following_activities_rela_3'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_participate_in_any_of_the_following_activities_rela_3',
  name: 'Did the facility participate in any of the following activities related to engagement with external organizations and other facilities? (SELECT all that apply with a "X":)',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FACILITY_COLLABORATES_WITH_OTHER_FACILITIES_ON_THE_DEVELOPMENT_',
      text: 'Facility collaborates with other facilities on the development of shared/joint training efforts',
      externalIds: [
        {
          id: 'ab-10-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe some of these training efforts:',
        externalIds: [
          {
            id: 'ab-10-1f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_PARTICIPATES_IN_MULTI_STAKEHOLDER_OR_INDUSTRY_FORUMS_T',
      text: 'Facility participates in multi-stakeholder or industry forums to develop full understanding of risks and challenges in the value chain',
      externalIds: [
        {
          id: 'ab-10-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe the forums the facility is participating in, and in what capacity (passive vs. active, voting, chair, etc.)',
        externalIds: [
          {
            id: 'ab-10-2f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_ENGAGES_WITH_KEY_LOCALLY_IMPACTED_STAKEHOLDERS_TO_IMPR',
      text: 'Facility engages with key locally impacted stakeholders to improve social and labor conditions in the value chain',
      externalIds: [
        {
          id: 'ab-10-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe by providing the stakeholder names and the nature and frequency of the dialogue:',
        externalIds: [
          {
            id: 'ab-10-3f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_ENGAGES_WITH_KEY_REGIONAL___INTERNATIONAL_STAKEHOLDERS',
      text: 'Facility engages with key regional / international stakeholders to improve social and labor conditions in the value chain',
      externalIds: [
        {
          id: 'ab-10-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe by providing the stakeholder names and the nature and frequency of the dialogue:',
        externalIds: [
          {
            id: 'ab-10-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FACILITY_ENGAGES__EITHER_DIRECTLY_OR_VIA_INDUSTRIAL_TRADE_ASSOC',
      text: 'Facility engages (either directly or via industrial trade association or tripartite initiatives) with local & district level Trade Unions to proactively address issues of concern to the industry',
      externalIds: [
        {
          id: 'ab-10-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-10-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-10-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-10-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FACILITY_COLLABORATES_WITH_OTHER_FACILITIES_ON_THE_DEVELOPMENT_',
                'FACILITY_PARTICIPATES_IN_MULTI_STAKEHOLDER_OR_INDUSTRY_FORUMS_T',
                'FACILITY_ENGAGES_WITH_KEY_LOCALLY_IMPACTED_STAKEHOLDERS_TO_IMPR',
                'FACILITY_ENGAGES_WITH_KEY_REGIONAL___INTERNATIONAL_STAKEHOLDERS',
                'FACILITY_ENGAGES__EITHER_DIRECTLY_OR_VIA_INDUSTRIAL_TRADE_ASSOC',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-17',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25060,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
